import { Box, Skeleton, styled } from '@mui/material';

export const MiniPlayerContainer = styled(Box)<{ isMiniPlayerHidden: boolean }>(
  ({ theme, isMiniPlayerHidden }) => ({
    containerType: 'inline-size',
    width: '100%',
    height: 100,
    display: isMiniPlayerHidden ? 'none' : 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'fixed',
    bottom: 0,
    background: theme.palette.grey[700],
    boxShadow: '0 -1px 4px 0 rgba(0, 0, 0, 0.4)',
    padding: theme.spacing(0, 4.5),
    zIndex: 100,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 1),
    },
    [theme.breakpoints.up('sm')]: {
      minHeight: 100,
    },
  })
);

export const PlaybackSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  marginRight: theme.spacing(1),
}));

export const WaveformSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  gap: theme.spacing(2),
}));

export const WaveformSkeleton = styled(Skeleton)(({ theme }) => ({
  height: theme.spacing(4),
  width: '100%',
  maxWidth: theme.spacing(50),
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const Waveform = styled(Box)(({ theme }) => ({
  height: theme.spacing(4),
  width: '100%',
  maxWidth: theme.spacing(50),
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));
